export const GET_REFERRAL_RULES_START = 'GET_REFERRAL_RULES_START';
export const GET_REFERRAL_RULES_SUCCESS = 'GET_REFERRAL_RULES_SUCCESS';
export const GET_REFERRAL_RULES_FAILED = ' GET_REFERRAL_RULES_FAILED';
export const SAVE_REFERRAL_RULE_START = 'SAVE_REFERRAL_RULE_START';
export const SAVE_REFERRAL_RULE_SUCCESS = 'SAVE_REFERRAL_RULE_SUCCESS';
export const SAVE_REFERRAL_RULE_FAILED = 'SAVE_REFERRAL_RULE_FAILED';
export const DELETE_REFERRAL_RULE_START = 'DELETE_REFERRAL_RULE_START';
export const DELETE_REFERRAL_RULE_SUCCESS = 'DELETE_REFERRAL_RULE_SUCCESS';
export const DELETE_REFERRAL_RULE_FAILED = 'DELETE_REFERRAL_RULE_FAILED';
export const SET_EDITABLE_REFERRAL_RULE = 'SET_EDITABLE_REFERRAL_RULE';


export const getReferralRulesStart = () => ({
  type: GET_REFERRAL_RULES_START
});

export const getReferralRulesSuccess = (data) => ({
  type: GET_REFERRAL_RULES_SUCCESS,
  data
});

export const getReferralRulesFailed = () => ({
  type: GET_REFERRAL_RULES_FAILED
});

export const saveReferralRuleStart = () => ({
  type: SAVE_REFERRAL_RULE_START
});

export const saveReferralRuleSuccess = (data) => ({
  type: SAVE_REFERRAL_RULE_SUCCESS,
  data
});

export const saveReferralRuleFaild = (error) => ({
  type: SAVE_REFERRAL_RULE_FAILED,
  error
});

export const deleteReferralRuleStart = () => ({
  type: DELETE_REFERRAL_RULE_START
});

export const deleteReferralRuleSuccess = (data) => ({
  type: DELETE_REFERRAL_RULE_SUCCESS,
  data
});

export const deleteReferralRuleFailed = (error) => ({
  type: DELETE_REFERRAL_RULE_FAILED,
  error
});

export const setEditableReferralRule = (rule) => ({
  type: SET_EDITABLE_REFERRAL_RULE,
  rule
});
